import { LegalLayout } from "@/components/legal/LegalLayout";

const KullanimSartlariPage = () => (
  <LegalLayout
    title="Kullanım Şartları / Terms of Use"
    description="insorganizasyon.org platformunu kullanırken geçerli olan genel koşullar."
    path="/kullanim-sartlari"
  >
    <section>
      <h2>1. Platformun Amacı</h2>
      <p>
        İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti. tarafından işletilen insorganizasyon.org internet sitesi, sivil
        toplum kuruluşlarıyla saha operasyonlarının planlanması, bağış ve kurumsal iş birliklerinin yönetilmesi amacıyla
        hizmet vermektedir. Platformu ziyaret eden gerçek ve tüzel kişiler işbu kullanım şartlarını kabul etmiş sayılır.
      </p>
    </section>

    <section>
      <h2>2. Fikri Mülkiyet Hakları</h2>
      <p>
        Sitede yer alan tüm bilgi, görsel, logo ve içerikler İns Organizasyon’a veya lisans veren üçüncü kişilere aittir.
        Yazılı izin olmaksızın kopyalanamaz, çoğaltılamaz veya ticari amaçla kullanılamaz. Kaynak gösterilmesi halinde bilgi
        amaçlı alıntılar yapılabilir.
      </p>
    </section>

    <section>
      <h2>3. Kullanıcı Yükümlülükleri</h2>
      <ul>
        <li>Platformu yürürlükteki mevzuata ve etik ilkelere uygun kullanmak.</li>
        <li>Gerçeğe aykırı, yanıltıcı veya üçüncü kişilerin haklarını ihlal eden içerik paylaşmamak.</li>
        <li>Bilgi güvenliğini tehlikeye atacak zararlı yazılım veya kod göndermemek.</li>
        <li>Hizmetlere ilişkin güncel iletişim bilgilerini sağlamak ve değişiklikleri bildirmek.</li>
      </ul>
    </section>

    <section>
      <h2>4. Hizmet Değişiklikleri</h2>
      <p>
        Platformda sunulan hizmetler, operasyonel gereklilikler veya mevzuat değişiklikleri sebebiyle güncellenebilir.
        İns Organizasyon önceden bildirimde bulunmaksızın sitedeki içerikleri değiştirme, askıya alma veya sonlandırma
        hakkını saklı tutar.
      </p>
    </section>

    <section>
      <h2>5. Sorumluluk Sınırı</h2>
      <p>
        Platformda yer alan bilgiler güncel tutulmaya çalışılmakla birlikte, sahadaki koşulların değişkenliği nedeniyle tüm
        bilgilerin doğruluğu garanti edilemez. Kullanıcı, kendi kararlarını verirken resmi sözleşme ve teyit yazışmalarına
        itibar etmelidir. İns Organizasyon dolaylı zararlardan sorumlu tutulamaz.
      </p>
    </section>

    <section>
      <h2>6. Üçüncü Taraf Bağlantılar</h2>
      <p>
        Platform üzerinden erişilen üçüncü taraf web siteleri ve hizmetler, kendi kullanım şartlarına tabidir. Bu bağlantıların
        içeriği veya güvenliği üzerinde İns Organizasyon’un kontrolü bulunmamaktadır.
      </p>
    </section>

    <section>
      <h2>7. Uyuşmazlık Durumunda</h2>
      <p>
        İşbu kullanım şartlarından kaynaklanan uyuşmazlıklarda Ankara Merkez Mahkemeleri ve İcra Müdürlükleri yetkilidir.
        Kullanıcılar taleplerini info@insorganizasyon.org adresi üzerinden iletebilirler.
      </p>
    </section>

    <hr />

    <section>
      <h2>English Summary</h2>
      <p>
        This website is operated by İns Organizasyon Ltd. and is intended for coordinating humanitarian field operations with
        NGOs. By using the site you agree to respect intellectual property, provide accurate information, and abstain from any
        harmful activity that could compromise information security. Services and content may change without prior notice and
        İns Organizasyon cannot be held liable for indirect losses arising from the use of the platform. For any questions
        please contact <a href="mailto:info@insorganizasyon.org">info@insorganizasyon.org</a>.
      </p>
    </section>
  </LegalLayout>
);

export default KullanimSartlariPage;
